import { render } from "./RecommendNewMail.vue?vue&type=template&id=74174809"
import script from "./RecommendNewMail.vue?vue&type=script&lang=js"
export * from "./RecommendNewMail.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__